export default __webpack_public_path__ + "static/media/agustin5.7b3818de.png";